import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <section className="py-10 md:py-24 bg-maternal-cream" data-id="element-164">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-gradient-to-br from-maternal-amber/10 to-maternal-gold/20 p-8 md:p-12 rounded-3xl relative" data-id="element-166">
          <Quote className="absolute top-6 left-6 w-12 h-12 text-maternal-amber/30 rotate-180" data-id="element-167" />

          <div className="relative z-10 text-center" data-id="element-168">
            <p className="text-xl md:text-2xl font-heading text-maternal-brown leading-relaxed mb-8 italic" data-id="element-169">
              "En los primeros 3 días, notarás que la tensión en el aire
              disminuye. No porque él sea 'bueno' de repente, sino porque tú has
              dejado de darle razones para pelear. Al séptimo día, verás cómo
              una charla de 10 minutos sucede de forma natural, sin que nadie
              termine gritando."
            </p>

            <div className="flex items-center justify-center gap-2 text-maternal-orange" data-id="element-170">
              {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-6 h-6 fill-current" viewBox="0 0 24 24" data-id="element-171">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-172" />
                </svg>)}
            </div>
            <p className="mt-4 font-bold text-maternal-brown" data-id="element-173">
              Resultados comprobados por cientos de madres
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}